
import { i18nText } from '@/locales';
import Vue from "vue";
import Component from "vue-class-component";
import { ITableColumn } from "@/entity/table/table.types";

@Component
export class ProductsTableMix extends Vue {
  get shortColumns(): ITableColumn[] {
    return [
      {
        title: i18nText("наименование"),
        dataIndex: "name",
        key: "name",
      },
    ];
  }
  get columns(): ITableColumn[] {
    return [
      {
        title: i18nText("наименование"),
        dataIndex: "name",
        key: "name",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
      }
      },
      {
        title: i18nText("цена продажи"),
        dataIndex: "selling_price_formated",
        key: "selling_price_formated",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
      }
      },
      {
        title: i18nText("ед.изм"),
        dataIndex: "unit_name",
        key: "unit_name",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
      }
      },
      {
        title: i18nText("комментарий"),
        dataIndex: "comment",
        key: "comment",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
      }
      },
      {
        title: "",
        dataIndex: "actions",
        scopedSlots: {
          customRender: "operation"
        },
      },
    ];
  }
  get mColumns(): ITableColumn[] {
    return [
      {
        title: i18nText("наименование"),
        dataIndex: "name",
        key: "name",
      },
      {
        title: i18nText("Артикул"),
        dataIndex: "vendor_code",
        key: "vendor_code",
        scopedSlots: { customRender: "vendor_code" },
      },
      {
        title: i18nText("Штрихкод"),
        dataIndex: "barcode",
        key: "barcode",
        scopedSlots: { customRender: "barcode" },
      },
      {
        title: i18nText("Цена продажи"),
        dataIndex: "selling_price",
        key: "selling_price",
        scopedSlots: { customRender: "selling_price" },
      },
      {
        title: i18nText("Масса Нетто"),
        dataIndex: "net_weight",
        key: "net_weight",
        scopedSlots: { customRender: "net_weight" },
      },
      {
        title: i18nText("Масса Брутто"),
        dataIndex: "gross_weight",
        key: "gross_weight",
        scopedSlots: { customRender: "gross_weight" },
      },

      {
        title: i18nText("Себестоимость"),
        dataIndex: "cost_price",
        scopedSlots: { customRender: "cost_price" },
      },
      {
        title: "",
        dataIndex: "actions",
        scopedSlots: { customRender: "operation" },
      },
    ];
  }
}
